import { Prisma, users } from '@prisma/client';
import axiosInstance from '../api';

interface UsersCreate extends Prisma.usersCreateInput {
  listingId?: string;
  /** MLS home from /browse to add to the new buyer's list (see Signup.tsx). */
  mlsListingId?: string;
  referralCode?: string;
  /**
   * Transient buy/sell signal from Signup.tsx step 1 ('BUYER' | 'SELLER' |
   * 'BOTH'). Never persisted to users.type — the backend reads it off the
   * request only to pick which post-signup Loops sequence to fire, then
   * discards it.
   */
  intent?: 'BUYER' | 'SELLER' | 'BOTH';
}

const usersService = {
  find: async ({ email }: { email?: string }): Promise<users[]> => {
    const response = await axiosInstance.get('/users', { params: { email } });
    return response.data;
  },
  post: async (user: UsersCreate, notify = true) => {
    const res = await axiosInstance.post('/users', user, {
      params: {
        notify,
      },
    });
    return res;
  },
  validateReferralCode: async (code: string): Promise<{ firstName: string; lastName: string } | null> => {
    try {
      const response = await axiosInstance.get(`/users/validate-referral/${code}`);
      return response.data;
    } catch (error) {
      return null;
    }
  },
  patch: async (user: Prisma.usersUpdateInput, userId: string) => {
    const res = await axiosInstance.patch(`/users/${userId}`, user);
    return res.data;
  },
  remove: async (userId: string) => {
    const res = await axiosInstance.delete(`/users/${userId}`);
    return res.data;
  },
};

export default usersService;
